import { get } from 'svelte/store';
import { Sentry } from '$lib/services/sentry';
import createPersistentStore from '$lib/utils/persistent-store';
import { AOFL_PRODUCT_NAMES, LINK_FROM_APP_PLATFORMS } from '$lib/utils/constants';
/**
 * @type {import('svelte/store').Writable<import('./types').App.AppStore>} AppStore
 */
export const app = createPersistentStore('meta-app-store', {
	meta: {
		acquisitionSource: '',
		appStore: '',
		appVersion: null,
		deviceId: null,
		inApp: false, // maps to is_webview
		isAmazonApp: false,
		isAmazonViewer: false,
		isAndroidApp: false,
		isAndroidViewer: '',
		isDesktopViewer: '',
		isIosApp: false,
		isIosViewer: '',
		isLinkFromApp: false,
		isLinkFromAppPlatform: null,
		isLinkFromEmail: false,
		isMac: false,
		isMobileViewer: '',
		isSamsungApp: false,
		isSmartTvApp: false,
		isSmarttvViewer: '',
		isTabletViewer: '',
		isWindows: false,
		lambdaExperimentInfo: '',
		localeCode: '',
		viewerCountry: 'US',
		viewerCountryRegion: '',
		viewerPostalCode: '',
	},
	global: {
		analyticsCookiesEnabled: true,
		appProduct: AOFL_PRODUCT_NAMES.ABCMOUSE_2_0,
		environment: 'development',
		experiments: [],
		featureFlags: {},
		gdprVisible: false,
		isFirstTimeVisit: true,
		linkFromAppPlatform: LINK_FROM_APP_PLATFORMS.DEFAULT, // ios, android, web
		loading: false,
		targetingCookiesEnabled: true,
	},
});

/**
 * @param {{ [key: string]: string | boolean | null; }} metaValues - new meta values
 * @returns {Promise<void>}
 */
export const setMetaStore = async (metaValues) => {
	app.update((current) => ({
		...current,
		meta: {
			...current.meta,
			...metaValues,
		},
	}));

	Object.keys(get(app).meta).forEach((key) => {
		Sentry.setTag(key, get(app)?.meta?.[key]);
	});

	Sentry.setContext('meta', get(app).meta);
	// Awaiting till next tick to ensure localStorage writes are complete before window navigate
	await new Promise((resolve) => setTimeout(resolve, 0));
};

/**
 * @param {{ [key: string]: string | boolean | import('./types').App.Experiment[] | null }} globalValues - new global values
 * @returns {Promise<void>}
 */
export const setGlobalStore = async (globalValues) => {
	app.set({ ...get(app), global: { ...get(app)?.global, ...globalValues } });

	Sentry.setTag('appProduct', get(app)?.global?.appProduct);
	Sentry.setTag('linkFromAppPlatform', get(app)?.global?.linkFromAppPlatform);
	Sentry.setTag('isFirstTimeVisit', get(app)?.global?.isFirstTimeVisit);
	Sentry.setContext('global', get(app)?.global);
	// Awaiting till next tick to ensure localStorage writes are complete before window navigate
	await new Promise((resolve) => setTimeout(resolve, 0));
};
